/** Reconnect bounded progress streams, refreshing auth on every connection. */
export function subscribeRunProgress(
  getUrl: () => Promise<string>,
  onMessage: (payload: unknown) => boolean
) {
  let stopped = false
  let source: EventSource | null = null
  let timer: ReturnType<typeof setTimeout>
  let retryMs = 1000

  const disconnect = () => {
    clearTimeout(timer)
    if (source) {
      source.onmessage = null
      source.onerror = null
      source.close()
      source = null
    }
  }
  const retry = () => {
    disconnect()
    if (stopped) return
    timer = setTimeout(connect, retryMs)
    retryMs = Math.min(retryMs * 2, 10000)
  }
  const connect = async () => {
    try {
      const url = await getUrl()
      if (stopped) return
      source = new EventSource(url)
      // The server sends counters every two seconds, even when unchanged.
      timer = setTimeout(retry, 20000)
      source.onmessage = (event) => {
        if (stopped) return
        try {
          const payload: unknown = JSON.parse(event.data)
          if (!onMessage(payload)) {
            stopped = true
            disconnect()
            return
          }
          retryMs = 1000
          clearTimeout(timer)
          timer = setTimeout(retry, 20000)
        } catch {
          retry()
        }
      }
      source.onerror = retry
    } catch {
      if (!stopped) retry()
    }
  }
  void connect()
  return () => {
    stopped = true
    disconnect()
  }
}
